import "./PrefooterAdsSkeleton.css";
const PrefooterAdsSkeleton = () => {
  return (
    <div className="container my-4">
      <div className="row g-3 justify-content-center">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="col-12 col-sm-6 col-md-6 col-lg-4 d-flex justify-content-center"
          >
            <div className="ad-card">
              <div className="ad-skeleton-block"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default PrefooterAdsSkeleton;